export default [
    {
        path: "subscribers-list",
        name: "subscriberLists",
        component: () =>
            import(
                /* webpackChunkName: "subscriber" */ "../pages/subscriber/SubscriberListView.vue"
            ),
        meta: {
            title: `subsciber list`,
        },
    },
    {
        path: "connected-users",
        name: "connectedusers",
        component: () =>
            import(
                /* webpackChunkName: "subscriber" */ "../pages/subscriber/ConnectedUserView.vue"
            ),
        meta: {
            title: `connected user`,
        },
    },
    {
        path: "add-single-subscriber",
        name: "addsinglesubscriber",
        component: () =>
            import(
                /* webpackChunkName: "AddSingleSubscriber" */ "../pages/subscriber/AddSingleSubscriber.vue"
            ),
        meta: {
            title: `Add Single Subscriber`,
        },
    },
    {
        path: "edit-single-subscriber/:id",
        name: "editsinglesubscriber",
        component: () =>
            import(
                /* webpackChunkName: "EditSingleSubscriber" */ "../pages/subscriber/EditSingleSubscriber.vue"
            ),
        meta: {
            title: `Edit Single Subscriber`,
        },
    }
];
